<template>
  <div id="call-only">
    <p>
      In diesem Fall ist keine online Anforderung der Nothilfe möglich, bitte
      rufen Sie uns an:
    </p>
    <p>
      <strong>Inland: </strong> <a class="oeamtc-link" href="tel:120">120</a>
    </p>
    <p>
      <strong>Ausland: </strong>
      <a class="oeamtc-link" href="tel:+4312512000">+43 1 25 120 00</a>
    </p>
  </div>
</template>

<script>
export default {
  name: 'CallOnly',
};
</script>

<style></style>
